import { render, staticRenderFns } from "./FieldsTab.vue?vue&type=template&id=24b557e4&scoped=true&"
import script from "./FieldsTab.vue?vue&type=script&lang=js&"
export * from "./FieldsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b557e4",
  null
  
)

export default component.exports